var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaXlsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "minerva_xls_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.951,
    height: 90.026,
    viewBox: "0 0 78.951 90.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139244",
    "data-name": "\\uD328\\uC2A4 139244",
    d: "M64.912,85.795H1.821A1.821,1.821,0,0,1,0,83.974V1.821A1.821,1.821,0,0,1,1.821,0H64.912a1.821,1.821,0,0,1,1.821,1.821V83.974A1.821,1.821,0,0,1,64.912,85.795Z",
    transform: "translate(12.218 4.231)",
    fill: "#939598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139245",
    "data-name": "\\uD328\\uC2A4 139245",
    d: "M43.376,0H1.821A1.821,1.821,0,0,0,0,1.821V83.974A1.821,1.821,0,0,0,1.821,85.8H64.912a1.821,1.821,0,0,0,1.821-1.821V22.6Z",
    transform: "translate(7.987 0)",
    fill: "#f1f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139246",
    "data-name": "\\uD328\\uC2A4 139246",
    d: "M.91,75.808A.913.913,0,0,1,0,74.9V.91A.914.914,0,0,1,.269.269.9.9,0,0,1,.91,0H27.077a.91.91,0,1,1,0,1.821H1.821V74.9A.91.91,0,0,1,.91,75.808ZM30.719,1.821a.91.91,0,1,1,.91-.91A.91.91,0,0,1,30.719,1.821Z",
    transform: "translate(9.807 1.82)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139247",
    "data-name": "\\uD328\\uC2A4 139247",
    d: "M62.181,0V61.225a1.821,1.821,0,0,1-1.821,1.821H0v2.731A1.821,1.821,0,0,0,1.821,67.6H64.912a1.821,1.821,0,0,0,1.821-1.821V4.405Z",
    transform: "translate(7.987 18.197)",
    fill: "#e6e7e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139248",
    "data-name": "\\uD328\\uC2A4 139248",
    d: "M64.457,0V61.3a1.821,1.821,0,0,1-1.821,1.821H0v.455A1.821,1.821,0,0,0,1.821,65.4H64.912a1.821,1.821,0,0,0,1.821-1.821V2.2Z",
    transform: "translate(7.987 20.4)",
    fill: "#d1d3d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139249",
    "data-name": "\\uD328\\uC2A4 139249",
    d: "M0,20.9A1.707,1.707,0,0,0,1.707,22.6H23.358L0,0Z",
    transform: "translate(51.362)",
    fill: "#d1d3d4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139250",
    "data-name": "\\uD328\\uC2A4 139250",
    d: "M43,16.255H1.821A1.821,1.821,0,0,1,0,14.434V1.821A1.821,1.821,0,0,1,1.821,0H43a1.821,1.821,0,0,1,1.821,1.821V14.434A1.821,1.821,0,0,1,43,16.255Z",
    transform: "translate(0 6.347)",
    fill: "#76a34f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139251",
    "data-name": "\\uD328\\uC2A4 139251",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(14.027 27.092)",
    fill: "#91b56b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139252",
    "data-name": "\\uD328\\uC2A4 139252",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(33.099 27.092)",
    fill: "#5a7a39"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139253",
    "data-name": "\\uD328\\uC2A4 139253",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(52.171 27.092)",
    fill: "#91b56b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139254",
    "data-name": "\\uD328\\uC2A4 139254",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(14.027 40.676)",
    fill: "#91b56b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139255",
    "data-name": "\\uD328\\uC2A4 139255",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(33.099 40.676)",
    fill: "#5a7a39"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139256",
    "data-name": "\\uD328\\uC2A4 139256",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(52.171 40.676)",
    fill: "#91b56b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139257",
    "data-name": "\\uD328\\uC2A4 139257",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(14.027 54.26)",
    fill: "#91b56b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139258",
    "data-name": "\\uD328\\uC2A4 139258",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(33.099 54.26)",
    fill: "#5a7a39"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139259",
    "data-name": "\\uD328\\uC2A4 139259",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(52.171 54.26)",
    fill: "#91b56b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139260",
    "data-name": "\\uD328\\uC2A4 139260",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(14.027 67.844)",
    fill: "#91b56b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139261",
    "data-name": "\\uD328\\uC2A4 139261",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(33.099 67.844)",
    fill: "#5a7a39"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139262",
    "data-name": "\\uD328\\uC2A4 139262",
    d: "M14.492,9.784H.91A.91.91,0,0,1,0,8.873V.91A.91.91,0,0,1,.91,0H14.492a.91.91,0,0,1,.91.91V8.873A.91.91,0,0,1,14.492,9.784Z",
    transform: "translate(52.171 67.844)",
    fill: "#91b56b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139377",
    "data-name": "\\uD328\\uC2A4 139377",
    d: "M10.033,10.57h-2.7l-2.4-3.7-2.453,3.7H0L3.666,5.354.076.186H2.77L5.113,3.748,7.511.186H10L6.381,5.264Zm8.706,0H11.531V.186h2.274V8.848h4.934Zm.865-.62v-2.2h.234a6.13,6.13,0,0,0,1.774,1.006,5.528,5.528,0,0,0,1.926.372,3.025,3.025,0,0,0,1.543-.345,1.064,1.064,0,0,0,.586-.958,1.031,1.031,0,0,0-.279-.758A2.267,2.267,0,0,0,24.33,6.6q-.558-.1-1.905-.407A3.878,3.878,0,0,1,20.372,5.13a2.749,2.749,0,0,1-.706-1.947,2.729,2.729,0,0,1,1.206-2.3A5.106,5.106,0,0,1,23.972,0,9.368,9.368,0,0,1,27.6.7V2.8h-.227a5.13,5.13,0,0,0-3.321-1.171,2.909,2.909,0,0,0-1.464.331,1.007,1.007,0,0,0-.575.9.987.987,0,0,0,.327.779,2.641,2.641,0,0,0,1.12.475q.792.145,1.767.382a5.227,5.227,0,0,1,1.454.534,3.063,3.063,0,0,1,.765.644,2.4,2.4,0,0,1,.427.775,2.994,2.994,0,0,1,.141.944A2.9,2.9,0,0,1,26.773,9.84a5.346,5.346,0,0,1-3.276.923A9.847,9.847,0,0,1,19.6,9.95Z",
    transform: "translate(8.364 9.255)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaXlsIcon);
export default __webpack_public_path__ + "static/media/minerva_xls_icon.6222c7d43f728015f4343affe88eb754.svg";
export { ForwardRef as ReactComponent };